import { render, staticRenderFns } from "./form-file.vue?vue&type=template&id=4d5fcaf6&scoped=true"
import script from "./form-file.vue?vue&type=script&lang=js"
export * from "./form-file.vue?vue&type=script&lang=js"
import style0 from "./form-file.vue?vue&type=style&index=0&id=4d5fcaf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5fcaf6",
  null
  
)

export default component.exports